class functionConstants {
  static CMS_BROKER_COMMUNICATION_ADD = "1";
  static CMS_BROKER_COMMUNICATION_EDIT = "2";
  static CMS_BROKER_COMMUNICATION_DELETE = "3";
  static CMS_BROKER_COMMUNICATION_VIEW = "4";
  static CMS_CATEGORIES_ADD = "5";
  static CMS_CATEGORIES_EDIT = "6";
  static CMS_CATEGORIES_DELETE = "7";
  static CMS_CATEGORIES_VIEW = "8";
  static CMS_EVENT_CALENDAR_ADD = "9";
  static CMS_EVENT_CALENDAR_EDIT = "10";
  static CMS_EVENT_CALENDAR_DELETE = "11";
  static CMS_EVENT_CALENDAR_VIEW = "12";
  static CMS_QUICK_LINKS_ADD = "13";
  static CMS_QUICK_LINKS_EDIT = "14";
  static CMS_QUICK_LINKS_DELETE = "15";
  static CMS_QUICK_LINKS_VIEW = "16";
  static CAMPAIGN_HEADER_KDOLLAR_CREATE = "17";
  static CAMPAIGN_HEADER_KDOLLAR_EDIT = "18";
  static CAMPAIGN_HEADER_KDOLLAR_DELETE = "19";
  static CAMPAIGN_HEADER_KDOLLAR_VIEW = "20";
  static CAMPAIGN_HEADER_CICONV_CREATE = "21";
  static CAMPAIGN_HEADER_CICONV_EDIT = "22";
  static CAMPAIGN_HEADER_CICONV_DELETE = "23";
  static CAMPAIGN_HEADER_CICONV_VIEW = "24";
  static CAMPAIGN_HEADER_BDELIGHT_CREATE = "25";
  static CAMPAIGN_HEADER_BDELIGHT_EDIT = "26";
  static CAMPAIGN_HEADER_BDELIGHT_DELETE = "27";
  static CAMPAIGN_HEADER_BDELIGHT_VIEW = "28";
  static CAMPAIGN_DETAILS_IMPORT = "29";
  static DOCUMENT_CENTER_UPLOAD = "30";
  static FILE_DOCUMENT_CENTER_DOWNLOAD = "31";
  static DOCUMENT_CENTER_EDIT = "32";
  static DOCUMENT_CENTER_DELETE = "33";
  static DOCUMENT_CENTER_VIEW = "34";
  static FILE_CAMPAIGN_HEADER_KDOLLAR_UPLOAD = "35";
  static FILE_CAMPAIGN_HEADER_CICONV_UPLOAD = "36";
  static FILE_DOCUMENT_CENTER_UPLOAD = "37";
  static CMS_BROKER_COMMUNICATION_APPROVE = "38";
  static CMS_CATEGORIES_APPROVE = "39";
  static CMS_EVENT_CALENDAR_APPROVE = "40";
  static CMS_QUICK_LINKS_APPROVE = "41";
  static CAMPAIGN_HEADER_KDOLLAR_APPROVE = "42";
  static CAMPAIGN_HEADER_CICONV_APPROVE = "43";
  static DOCUMENT_CENTER_APPROVE = "44";
  static FILE_CAMPAIGN_DOWNLOAD = "45";
  static DOCUMENT_CENTER_VISIBILITY = "46";
}

export default functionConstants;
